import { appConfig } from '../../appConfig';

const Header = () => {
  const { Header } = appConfig;

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-1">
          <img
            src={Header.logo}
            alt={Header.altText}
            style={{ width: '84px' }}
          />
        </div>
      </div>
    </div>
  );
};

export default Header;
